module.exports = __webpack_public_path__ + "img/knife.2cbbe7ba.png";